import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Iterable, List, Map } from 'immutable';

import FieldError from './FieldError';

/**
 * Popup request error (`isPopupFetchingError`): message and the list of detailed errors.
 *
 * @param {object} props Props.
 * @param {Map} [props.error] Request error, nothing is rendered when it is empty.
 */
const FetchingError = ({ error }) => {
  if (!error) return null;

  const errors = error.get('errors', List());
  const messages = (Iterable.isKeyed(errors) ? errors.valueSeq() : errors).flatten();

  return (
    <div className="has-error">
      {messages.map(message => (
        <FieldError key={message} message={message} />
      ))}
    </div>
  );
};

FetchingError.propTypes = {
  error: PropTypes.instanceOf(Map),
};

export default memo(FetchingError);
